import { render, staticRenderFns } from "./PromotionsSlider.vue?vue&type=template&id=5024837c&scoped=true&"
import script from "./PromotionsSlider.vue?vue&type=script&lang=js&"
export * from "./PromotionsSlider.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsSlider.vue?vue&type=style&index=0&id=5024837c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024837c",
  null
  
)

export default component.exports